module.exports = __webpack_public_path__ + "img/ai-green.97b2f95b.svg";